import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_PURCHASEHISTORY,
  DELETE_PURCHASEHISTORY,
  UPDATE_PURCHASEHISTORY,
  ADD_NEW_PURCHASEHISTORY,
} from "./actionType";

import {
  getPurchaseHistorySuccess,
  getPurchaseHistoryFail,
  deletePurchaseHistorySuccess,
  deletePurchaseHistoryFail,
  updatePurchaseHistorySuccess,
  updatePurchaseHistoryFail,
  addPurchaseHistorySuccess,
  addPurchaseHistoryFail,
} from "./action";

//Include Both Helper File with needed carriers
import {
  approvePurchaseHistoryApi,
  getPurchaseHistoryApi,
  updatePurchaseHistoryApi,
  deletePurchaseHistoryApi,
  addNewPurchaseHistoryApi
} from "../../helpers/backend_helper";

function* getPurchaseHistory({ payload: purchaseHistory }) {
  try {
    const response = yield call(getPurchaseHistoryApi, purchaseHistory);
    yield put(getPurchaseHistorySuccess(GET_PURCHASEHISTORY, response.data));
  } catch (error) {
    yield put(getPurchaseHistoryFail(GET_PURCHASEHISTORY, error));
  }
}

function* onUpdatePurchaseHistory({ payload: purchaseHistory }) {
  try {
    if (purchaseHistory.setApprove) {
      const response = yield call(approvePurchaseHistoryApi, purchaseHistory);
      yield put(updatePurchaseHistorySuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updatePurchaseHistoryApi, purchaseHistory);
      yield put(updatePurchaseHistorySuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updatePurchaseHistoryFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeletePurchaseHistory({ payload: purchaseHistory }) {
  try {
    const response = yield call(deletePurchaseHistoryApi, purchaseHistory);
    yield put(deletePurchaseHistorySuccess({ purchaseHistory, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deletePurchaseHistoryFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewPurchaseHistory({ payload: purchaseHistory }) {
  try {
    const response = yield call(addNewPurchaseHistoryApi, purchaseHistory);
    yield put(addPurchaseHistorySuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addPurchaseHistoryFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetPurchaseHistory() {
  yield takeEvery(GET_PURCHASEHISTORY, getPurchaseHistory);
}

export function* watchUpdatePurchaseHistory() {
  yield takeEvery(UPDATE_PURCHASEHISTORY, onUpdatePurchaseHistory);
}

export function* watchDeletePurchaseHistory() {
  yield takeEvery(DELETE_PURCHASEHISTORY, onDeletePurchaseHistory);
}

export function* watchAddNewPurchaseHistory() {
  yield takeEvery(ADD_NEW_PURCHASEHISTORY, onAddNewPurchaseHistory);
}

function* purchaseHistorySaga() {
  yield all([
    fork(watchGetPurchaseHistory),
    fork(watchDeletePurchaseHistory),
    fork(watchUpdatePurchaseHistory),
    fork(watchAddNewPurchaseHistory)
  ]);
}

export default purchaseHistorySaga;
